import React from 'react';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import UserAvatar from '../../../../../components/UserAvatar';
import ExpandableSection from '../../../../../components/ExpandableSectionMembers';
import teamIcon from '../../../../../assets/images/teams-icon-blue.svg';

import MultipleUsersIcon from '../../../../../components/Iconoclast/MultipleUsersIcon';
import styles from '../../../../../assets/styles/globals.scss';
import './SelectMemberList.scss';

class SelectMemberList extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      members: null,
      searchString: null,
    };

    this.handleSearchMembers = this.handleSearchMembers.bind(this);
  }

  handleSelectMember(member) {
    if (this.props.selectMember) {
      this.props.selectMember(member);
    }
    if (this.props.showProjectMembers){
      this.props.showProjectMembers(true);
    }
  }

  componentDidMount() {
    this.setState({ members: this.props.members });
  }

  handleSearchMembers(e) {
    let query;
    query = e.target.value;
   
    if (query) {
      var { members } = this.state;
      const newMembers = members.filter(m => m.first_name.toLowerCase().includes(query.toLowerCase()));
      members = newMembers;
      this.setState({ members: newMembers });
      this.forceUpdate();

    }else {
      this.setState({ members: this.props.members });
     
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      members: newProps.members,
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.state.members != nextProps.members;
  }

  userDisplay(unexpandedUser, isButtonAdd) {
    let user = unexpandedUser;
    
    let company=typeof user.company!='undefined'?user.company.name: user.companies && user.companies.length>0?user.companies[0].name:'';
    return (
        <div className='assigned-to-user' id={ 'user-'+user.id } key={ 'user-'+user.id } >
          {
            !user.first_name?<div className={''}>
            <img className={'teamicon'} src={teamIcon} alt={'teams'}/>
            </div>:
            <UserAvatar user={ user } extraLarge={true} />
            
          }
        
          <div className={user.first_name?'user-info':'team-info'}>
            <h2>
              { `${user.first_name?user.first_name.toUpperCase():user.name.toUpperCase()} ${user.last_name?user.last_name.toUpperCase():''}` }
            </h2>
            { !user.first_name?null:
            <p>
              { company}
            </p>
            }
            
          </div>   
            
            <button className='user-button' onClick={ () => this.handleSelectMember(user) }>
            {this.props.type=='project'?'REMOVE':'ADD'}
            </button>
          
        </div>
      );
   
  }

  render() {

    // memberList.sort((u1, u2) => {
    //   const u1_last_name = u1.last_name ? u1.last_name : u1.name
    //   const u2_last_name = u2.last_name ? u2.last_name : u2.name
    //   const result = u1_last_name.localeCompare(u2_last_name)
    //   if (result == 0) {
    //     const u1_first_name = u1.first_name ? u1.first_name : u1.name
    //     const u2_first_name = u2.first_name ? u2.first_name : u2.name
    //     return u1_first_name.localeCompare(u2_first_name)
    //   }
    //   return result;
    // })

    let style = {};
    if (this.props.height) {
      style.height = this.props.height;
    }

    // let caption = null
    // if (this.props.caption) {
    //   caption = <div className="mobile-member-list-caption">{this.props.caption}</div>
    // }
  //let availableUsers=this.props.members.users && this.props.members.users

    let count=0;
    for (let i=0; i<this.props.members.length; i++) {
      if (!this.props.members.first_name){
        count+=1;

      }
    }
    return(
      <div className='MobileAssignmentTab'>
        <div className='assignment-container'>
            <ExpandableSection initiallyExpanded={true} name={ this.props.title.toUpperCase()} numberUsers={this.props.members.length!=0?this.props.members.length:0} 
            teams={count>0? count:0} >
                {
                  this.props.members.length > 0 && this.props.members.map((user) => {
                    return this.userDisplay(user, true);
                  })
                }
           
                {
                  this.props.members.length == 0 && (
                    <div className='assignment-container__empty'>
                      <MultipleUsersIcon iconColor={styles.lightElement} />
                      <p>There are no available project members. Navigate to projects and add members in the web application.</p>
                    </div>
                  )
                }
              </ExpandableSection>
        </div>
      </div>
    );
  }
}

export default SelectMemberList;




// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/MobileSelectProjectMember/MobileSelectMemberList/index.js